import { ActionDefinition, ActionDefinitionSparePartReference, ActivationPeriod, Customer, Location, Thing, ThingDefinition, User, WorkOrder } from ".";

export class ActionStatus {
    public id: string;
    public thingId: string;
    public thing: Thing;
    public thingDefinitionId: string;
    public thingDefinition: ThingDefinition;
    public locationId: string;
    public location: Location;
    public customerId: string;
    public customer: Customer;
    public actionDefinitionId: string;
    public actionDefinition: ActionDefinition;
    public startTimestamp: number;
    public timestamp: number;
    public state: ActionState;
    public userId: string;
    public user: User;
    public lastDoneTimestamp: number;
    public lastDiscardedTimestamp: number;
    public period: ActivationPeriod;
    public periodCount: number;
    public dayOfMonth: number;
    public dayOfWeek: number;
    public dueTimestamp: number;
    public wearStatus: any;
    public notes: string;
    public discardReasonId: string;
    public discardReason: ActionDiscardReason;
    public uncoded: boolean;
    public workOrderId: string;
    public workOrder: WorkOrder;
    public executionState: ActionExecutionState;
    public issueTypeId: string;
    public issueType: ActionIssueType;
    public workOrderNative: boolean;
    public properties: { [name: string]: string | number };
    public workTime: number;
    public sparePartReferences: ActionDefinitionSparePartReference[];
    public attachments: ActionStatusAttachment[];
    public executionTimestamp: number;
    public executionStartTimestamp: number;
    public usage: number;
}

export enum ActionState {
    TODO = "TODO",
    DONE = "DONE",
    DISCARDED = "DISCARDED"
}

export class ActionDiscardReason {
    id: string;
    code: string;
    label: string;
}

export enum ActionExecutionState {
    DONE = "DONE",
    DONE_WITH_ISSUE = "DONE_WITH_ISSUE",
    DISCARDED = "DISCARDED"
}

export class ActionIssueType {
    id: string;
    value: string;
    label: string;
    attachmentRequired: boolean;
}

export class ActionStatusAttachment {
    filename: string;
    s3Key: string;
    url: string;
    type: ActionAttachmentType;
}

export enum ActionAttachmentType {
    IMAGE = "IMAGE",
    OTHER = "OTHER"
}